import { useTranslation } from "react-i18next";
import { Trash2 } from "lucide-react";
import clsx from "clsx";
import { Button } from "components/common/Button";
import type { MouseEvent as ReactMouseEvent } from "react";
import type { PendingRoomRowProps } from "./types";

export const PendingRoomRow = ({
  room,
  isSelected,
  onSelect,
  onRename,
  onRemove,
}: PendingRoomRowProps) => {
  const { t } = useTranslation();

  const handleRemoveClick = (event: ReactMouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onRemove(room.id);
  };

  // Selecting toggles, so an already selected room must not be deselected by a focus
  const handleNameFocus = () => {
    if (!isSelected) onSelect(room.id);
  };

  return (
    <div
      className={clsx(
        "flex items-center gap-2 p-3 rounded-md border cursor-pointer",
        isSelected
          ? "border-teal-400 bg-teal-50"
          : "border-gray-200 hover:bg-gray-50",
      )}
      onClick={() => onSelect(room.id)}
    >
      <input
        type="text"
        value={room.name}
        placeholder={t("smartSurveyor.rooms.namePlaceholder")}
        aria-label={t("smartSurveyor.rooms.nameLabel")}
        maxLength={120}
        onFocus={handleNameFocus}
        onClick={(event) => event.stopPropagation()}
        onChange={(event) =>
          onRename({ id: room.id, name: event.target.value })
        }
        className="flex-1 min-w-0 rounded-md border border-gray-300 bg-white px-2 py-1 text-sm text-gray-900 outline-none focus:border-blue-500"
      />
      <Button
        variant="text"
        size="sm"
        onClick={handleRemoveClick}
        aria-label={t("common.delete")}
        className="!p-0 !text-gray-400 hover:!text-red-600"
      >
        <Trash2 size={18} />
      </Button>
    </div>
  );
};
